import {Map} from 'immutable';
import en from '../i18n/en';
import he from '../i18n/he';
import heFemale from '../i18n/he_female';

// Hebrew female is based on hebrew male and only overrides the strings it wants to override
const hebrewFemale = {
  ...he,
  ...heFemale
};

const SWITCH_LANG = 'SWITCH_LANG';
const DEFAULT_LANGUAGE = 'he';

const i18nFuncs = new Map({en, he, he_female: hebrewFemale}).map((json) => (key) => json[key] || `[I18N ERROR] Not found: ${key}`);

const invalidI18n = (key) => `[I18N ERROR] Invalid Language. Key ${key}`;

const initialState = { 
  i18n: i18nFuncs.get(DEFAULT_LANGUAGE, invalidI18n),
  language: DEFAULT_LANGUAGE 
}

const i18n = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_LANG:
      return {
        i18n: i18nFuncs.get(action.payload, invalidI18n),
        language: action.payload
      };
    default:
      return state;
  }
};

export default i18n;

export const getLanguage = (state) => state.lang.language;
export const geti18n = (state) => state.lang.i18n;

export const changeLanguage = language => ({
  type: SWITCH_LANG,
  payload: language
});


// WEBPACK FOOTER //
// ./src/reducers/i18n.js